var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-label": "bed",
    boxSize: 4,
    style: {
      height: 16,
      width: 16,
      color: "rgb(94, 100, 115)",
      marginBottom: "-2px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 12H4C2.895 12 2 12.895 2 14V16.933C2 17.485 2.448 17.933 3 17.933H21C21.552 17.933 22 17.485 22 16.933V14C22 12.895 21.105 12 20 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12V6.933C4 5.276 5.343 3.933 7 3.933H17C18.657 3.933 20 5.276 20 6.933V12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18V19.93 M3 18V19.93 M7.5 12V12C7.5 10.343 8.843 9 10.5 9H13.5C15.157 9 16.5 10.343 16.5 12V12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.b1bc4dd775823e51738fc220f4b1b3ab.svg";
export { ForwardRef as ReactComponent };